import * as i1 from '@angular/common/http';
import { HttpClientJsonpModule } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Component, Inject, NgModule } from '@angular/core';
import { get } from 'lodash-es';
import moment from 'moment';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

class NavHeaderWeatherWidgetComponent {
    constructor(http, appDefaults) {
        this.http = http;
        this.appDefaults = appDefaults;
        this.url = this.appDefaults.WEATHER_API;
    }
    ngOnInit() {
        this.http
            .get(this.url)
            .toPromise()
            .then((result) => {
            const weatherData = get(result, 'current_observation');
            if (!result || !weatherData) {
                return;
            }
            this.observation = moment(get(weatherData, 'observation_time_rfc822.0', new Date()), 'ddd, DD MMM YYYY HH:mm:ss ZZ', 'en');
            this.observationDow = this.observation.format('dddd ');
            this.observationDate = this.observation.format('MMMM D, YYYY');
            this.weatherIcon = this.getWeatherIcon(weatherData.weather[0]);
            this.tempF = weatherData.temp_f;
            this.tempC = weatherData.temp_c;
        })
            .catch(() => {
            console.error('Unable to retrieve weather info');
        });
    }
    getWeatherIcon(conditions) {
        let currentIcon = '';
        switch (conditions) {
            case 'A Few Clouds':
            case 'A Few Clouds with Haze':
            case 'A Few Clouds and Breezy':
            case 'Partly Cloudy':
                currentIcon = 'icon-weather-day-partly-cloudy';
                break;
            case 'Mostly Cloudy':
            case 'Mostly Cloudy with Haze':
            case 'Mostly Cloudy and Breezy':
                currentIcon = 'icon-weather-cloudy';
                break;
            case 'Haze':
            case 'Fog/Mist':
            case 'Fog':
            case 'Freezing Fog':
            case 'Shallow Fog':
            case 'Partial Fog':
            case 'Patches of Fog':
            case 'Fog in Vicinity':
            case 'Freezing Fog in Vicinity':
            case 'Shallow Fog in Vicinity':
            case 'Partial Fog in Vicinity':
            case 'Patches of Fog in Vicinity':
            case 'Light Freezing Fog':
            case 'Heavy Freezing Fog':
            case 'Showers in Vicinity':
            case 'Showers in Vicinity Fog/Mist':
            case 'Showers in Vicinity Fog':
            case 'Showers in Vicinity Haze':
                currentIcon = 'icon-weather-light-rain';
                break;
            case 'Rain':
            case 'Heavy Rain':
            case 'Rain Fog/Mist':
            case 'Heavy Rain Fog/Mist':
            case 'Rain Fog':
            case 'Heavy Rain Fog':
                currentIcon = 'icon-weather-heavy-rain';
                break;
            case 'Fair':
            case 'Clear':
            case 'Fair with Haze':
            case 'Clear with Haze':
            case 'Fair and Breezy':
            case 'Clear and Breezy':
            case 'Windy':
            case 'Breezy':
            case 'Fair and Windy':
            case 'A Few Clouds and Windy':
            case 'Partly Cloudy and Windy':
            case 'Mostly Cloudy and Windy':
            case 'Overcast and Windy':
                currentIcon = 'icon-weather-day-clear';
                break;
            default:
                currentIcon = 'icon-weather-severe';
                break;
        }
        return currentIcon;
    }
}
NavHeaderWeatherWidgetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderWeatherWidgetComponent, deps: [{ token: i1.HttpClient }, { token: 'AppDefaults' }], target: i0.ɵɵFactoryTarget.Component });
NavHeaderWeatherWidgetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: NavHeaderWeatherWidgetComponent, selector: "upr-nav-header-weather-widget", ngImport: i0, template: "<div class=\"park-info-weather\">\r\n\t<i *ngIf=\"weatherIcon\" class=\"icon {{ weatherIcon }}\"></i>\r\n\t<p *ngIf=\"tempF && tempC\" class=\"park-info-temp\">\r\n\t\t{{ tempF }}\u02DAF / {{ tempC }}\u02DAC\r\n\t</p>\r\n</div>\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.park-info-weather{display:flex}i,p{font-size:12px;color:#fff;font-weight:700}p{margin-bottom:0}\n"], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderWeatherWidgetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-nav-header-weather-widget', template: "<div class=\"park-info-weather\">\r\n\t<i *ngIf=\"weatherIcon\" class=\"icon {{ weatherIcon }}\"></i>\r\n\t<p *ngIf=\"tempF && tempC\" class=\"park-info-temp\">\r\n\t\t{{ tempF }}\u02DAF / {{ tempC }}\u02DAC\r\n\t</p>\r\n</div>\r\n", styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.park-info-weather{display:flex}i,p{font-size:12px;color:#fff;font-weight:700}p{margin-bottom:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }]; } });

class NavHeaderWeatherWidgetModule {
}
NavHeaderWeatherWidgetModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderWeatherWidgetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NavHeaderWeatherWidgetModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderWeatherWidgetModule, declarations: [NavHeaderWeatherWidgetComponent], imports: [CommonModule, HttpClientJsonpModule], exports: [NavHeaderWeatherWidgetComponent, CommonModule] });
NavHeaderWeatherWidgetModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderWeatherWidgetModule, providers: [], imports: [[CommonModule, HttpClientJsonpModule], CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NavHeaderWeatherWidgetModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NavHeaderWeatherWidgetComponent],
                    imports: [CommonModule, HttpClientJsonpModule],
                    providers: [],
                    exports: [NavHeaderWeatherWidgetComponent, CommonModule]
                }]
        }] });

export { NavHeaderWeatherWidgetComponent, NavHeaderWeatherWidgetModule };
